declare namespace $ {

	type $mol_view__sub_bog_ui_toast_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_ui_toast_2 = $mol_type_enforce<
		ReturnType< $bog_ui_toast['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_ui_toast_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	export class $bog_ui_toast extends $mol_view {
		Icon( ): $mol_icon_information
		Body( ): $mol_view
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		message( ): string
		type( ): string
		closeable( ): boolean
		close( next?: any ): any
		sub( ): readonly(any)[]
		attr( ): ({ 
			'bog_ui_toast_type': ReturnType< $bog_ui_toast['type'] >,
			'bog_ui_toast_closeable': ReturnType< $bog_ui_toast['closeable'] >,
		}) 
	}
	
}

//# sourceMappingURL=toast.view.tree.d.ts.map